/* ── Auto-load BOGO discount guard wherever Bundle offers are rendered ── */
(function () {
  if (window.__mmBogoGuardLoaded) return;
  try {
    var s = document.currentScript;
    var base = s && s.src ? s.src.replace(/mm-bundle-offer\.js.*$/, "") : "";
    var g = document.createElement("script");
    g.src = base + "mm-bogo-guard.js";
    g.defer = true;
    document.head.appendChild(g);
  } catch (e) {}
})();

/* ── MM Bundle Offer v3 (Multi-Bundle Support & Sandboxed) ── */
(function() {
  var mmoLang = "en";
  var mmoSettings = {};

  function mmExtractId(id) {
    if (id == null || id === "") return "";
    return String(id).split("/").pop();
  }

  function mmCartVariantId(id) {
    var s = mmExtractId(id);
    if (!s) return null;
    var n = Number(s);
    return Number.isSafeInteger(n) ? n : s;
  }

  function mmBundleDealDiscount(vs, bundleOffer) {
    if (bundleOffer.discountMode === "PER_PRODUCT") {
      var per = parseFloat(vs.discount);
      if (!Number.isNaN(per) && per > 0) return String(per);
    }
    return String(bundleOffer.discountValue != null ? bundleOffer.discountValue : "0");
  }

  function mmMoneyDiv() {
    var el = document.querySelector('[data-mm-product-offers], [data-mm-cart-offers], [data-mm-offers]');
    if (window.MMOffers && window.MMOffers.moneyDiv) {
      return window.MMOffers.moneyDiv(el);
    }
    var htmlDiv = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (htmlDiv === 100 || htmlDiv === 1000) return htmlDiv;
    return 1000;
  }

  function mmFormatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    var div = mmMoneyDiv();
    if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.formatWithTax === 'function') {
      return window.mmCurrencyConfig.formatWithTax(cents, div);
    }
    if (window.MMOffers && window.MMOffers.fmtPrice) {
      return window.MMOffers.fmtPrice(cents, document.querySelector('[data-mm-product-offers]'));
    }
    var tax = parseFloat((mmoSettings && mmoSettings.taxPercentage) || 0) / 100;
    var taxedCents = cents * (1 + tax);
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BHD';
    var dec = (c === 'BHD' || c === 'KWD' || c === 'OMR' || c === 'JOD') ? 3 : 2;
    var val = (taxedCents / div).toFixed(dec);
    if (mmoLang === 'ar') {
      var sym = 'د.ب';
      if (c === 'SAR') sym = 'ر.س';
      else if (c === 'AED') sym = 'د.إ';
      else if (c === 'KWD') sym = 'د.ك';
      return val + ' ' + sym;
    }
    return val + ' ' + c;
  }

  function init() {
    var containers = document.querySelectorAll("[data-mm-bundle-block]");
    console.log("[MM Bundle] init call. Containers found:", containers.length);
    if (!containers.length) {
      if (window.mmOfferWidgetReady) window.mmOfferWidgetReady(false);
      else if (window.MMProductOffers) window.MMProductOffers.widgetReady(false);
      return;
    }
    // We only process each container once
    containers.forEach(function(c) {
      if (!c.dataset.processed) {
        c.dataset.processed = "1";
        fetchAndProcess(c);
      }
    });
  }

  async function fetchAndProcess(container) {
    var currentHandle = container.dataset.productHandle;
    var shown = false;
    mmoLang = (window.Shopify && window.Shopify.locale) || "en";
    if (mmoLang.indexOf("ar") === 0) mmoLang = "ar";

    try {
      var pf = window.__mmPrefetch;
      var url = window.MMOffers && window.MMOffers.offersApiUrl
        ? window.MMOffers.offersApiUrl({ productHandle: currentHandle })
        : "/apps/mm-app/api/offers?productHandle=" + encodeURIComponent(currentHandle);
      var resFn = pf ? pf.fetchOffers(currentHandle) : fetch(url).then(function(r) { return r.ok ? r.json() : { offers: [] }; });
      var data = await resFn;
      var allBundles = (data.offers || []).filter(function(o) { return o.type === "BUNDLE"; });

      if (!allBundles.length) return;
      console.log("[MM Bundle] Found", allBundles.length, "bundles for product.");

      // For each bundle, we need a container. We use the original for the first one, and clone for the rest.
      allBundles.forEach(function(bundleOffer, idx) {
        var el = container;
        if (idx > 0) {
          el = container.cloneNode(true);
          container.parentNode.insertBefore(el, container.nextSibling);
        }
        processSingleBundle(el, bundleOffer, data.settings || {});
        shown = true;
      });

    } catch (err) {
      console.error("[MM Bundle] fetch error", err);
    } finally {
      if (window.MMProductOffers) window.MMProductOffers.widgetReady(shown);
      else if (window.mmOfferWidgetReady) window.mmOfferWidgetReady(shown);
    }
  }

  async function processSingleBundle(container, bundleOffer, settings) {
    if (mmoLang === "ar") container.classList.add("mm-rtl");
    mmoSettings = settings;
    try {
      var themeConfig = JSON.parse(settings.shopifyDealsConfig || "{}");
      if (themeConfig.eidThemeEnabled) container.classList.add("mm-eid-theme");
    } catch(e) {}

    try {
      var bundleItems = [];
      try { bundleItems = JSON.parse(bundleOffer.bundleItemsConfig || "[]"); } catch(e) {}
      if (!Array.isArray(bundleItems) || !bundleItems.length) return;

      var titleEl = container.querySelector(".mm-bof-title");
      if (titleEl) {
        var offerTitle = mmoLang === "ar" ? (bundleOffer.titleAr || bundleOffer.title) : bundleOffer.title;
        titleEl.textContent = offerTitle || container.dataset.sectionTitle;
      }

      if (bundleOffer.endsAt) {
        var timerEl = container.querySelector(".js-mm-bof-timer");
        if (timerEl) {
          timerEl.hidden = false;
          timerEl.classList.add("mm-meta-visible");
          timerEl.style.setProperty("display", "inline-flex", "important");
          startTimer(bundleOffer.endsAt, timerEl.querySelector("span"));
        }
      }

      if (bundleOffer.customerQuantity > 0) {
        var scarEl = container.querySelector(".js-mm-bof-scarcity");
        if (scarEl) {
          var scarLbl = mmoLang === "ar" ? (mmoSettings.onlyLeftAr || "متبقي {quantity} فقط!") : (mmoSettings.onlyLeftEn || "Only {quantity} left!");
          scarEl.textContent = scarLbl.replace("{quantity}", bundleOffer.customerQuantity);
          scarEl.hidden = false;
          scarEl.classList.add("mm-meta-visible");
          scarEl.style.setProperty("display", "block", "important");
        }
      }

      var pf2 = window.__mmPrefetch;
      var prodPromises = bundleItems.map(function(item) {
        if (item && item.type === "choice_group") {
          return Promise.all((item.options || []).map(function(option) {
            if (pf2) return pf2.fetchProduct(option.handle);
            var rootChoice = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
            var urlChoice = (rootChoice + "products/" + option.handle + ".js").replace("//", "/");
            return fetch(urlChoice).then(function(r) { return r.ok ? r.json() : null; }).catch(function() { return null; });
          }));
        }
        if (pf2) return pf2.fetchProduct(item.handle);
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        var url = root + "products/" + item.handle + ".js";
        url = url.replace("//", "/");
        return fetch(url).then(function(r) { 
          return r.ok ? r.json() : null; 
        }).catch(function(e) { 
          return null; 
        });
      });
      var products = await Promise.all(prodPromises);

      var productsEl = container.querySelector(".js-mm-bundle-products");
      if (!productsEl) return;

      var variantSelections = {};
      var html = "";

      bundleItems.forEach(function(item, idx) {
        var prod = products[idx];
        var isChoiceGroup = item && item.type === "choice_group";
        var choiceProducts = isChoiceGroup ? (Array.isArray(prod) ? prod : []).filter(Boolean) : null;
        if (isChoiceGroup) prod = choiceProducts[0];
        if (!prod) return;

        var selectedOption = isChoiceGroup ? ((item.options || [])[0] || {}) : item;
        var itemQty = Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity || selectedOption.quantity || selectedOption.qty) || 1));
        var allVariants = prod.variants || [];
        var showVariants = allVariants;

        if (selectedOption.variantMode === "specific") {
          var numIds = (selectedOption.selectedVariantIds || []).map(function(id) { return String(id).split("/").pop(); });
          if (numIds.length) showVariants = allVariants.filter(function(v) { return numIds.indexOf(String(v.id)) > -1; });
          if (!showVariants.length) showVariants = allVariants.slice(0, 1);
        }

        if ((!isChoiceGroup && item.isFixedSelection && showVariants.length > 1) || (isChoiceGroup && selectedOption.isFixedSelection && showVariants.length > 1)) {
          variantSelections[idx] = {
            handle: selectedOption.handle || item.handle,
            isFixed: true,
            selected: showVariants,
            qty: itemQty,
            discount: selectedOption.discount || item.discount || "0",
            choiceGroupId: isChoiceGroup ? (item._uid || item.id || ("choice-" + idx)) : null
          };
        } else {
          var defV = showVariants[0] || allVariants[0];
          variantSelections[idx] = {
            handle: selectedOption.handle || item.handle,
            isFixed: false,
            variantId: defV ? mmExtractId(defV.id) : null,
            price: defV ? defV.price : 0,
            qty: itemQty,
            discount: selectedOption.discount || item.discount || "0",
            choiceGroupId: isChoiceGroup ? (item._uid || item.id || ("choice-" + idx)) : null,
            options: isChoiceGroup ? (item.options || []) : null
          };
        }

        var selHtml = "";
        if (isChoiceGroup) {
          selHtml += '<select class="mm-bof-product-choice" data-idx="' + idx + '">' +
            choiceProducts.map(function(p, optionIndex) {
              return '<option value="' + optionIndex + '">' + p.title + '</option>';
            }).join("") + '</select>';
          selHtml += '<div class="mm-bof-variant-slot" data-idx="' + idx + '">';
          if (selectedOption.isFixedSelection && showVariants.length > 1) {
            selHtml += '<div class="mm-bof-fixed-list"><div class="mm-bof-fixed-header">' +
              (mmoLang === "ar" ? "الاختيارات المشمولة" : "Included variants") + '</div>' +
              showVariants.map(function(v) { return '<div class="mm-bof-fixed-item">' + v.title + '</div>'; }).join("") + '</div>';
          } else if (showVariants.length > 1) {
            selHtml += '<select class="mm-bof-select" data-idx="' + idx + '">' +
              showVariants.map(function(v) { return '<option value="' + v.id + '" data-p="' + v.price + '">' + v.title + '</option>'; }).join("") + '</select>';
          } else if (showVariants[0] && showVariants[0].title !== "Default Title") {
            selHtml += '<div class="mm-bof-single-variant">' + showVariants[0].title + '</div>';
          }
          selHtml += '</div>';
        } else if (item.isFixedSelection && showVariants.length > 1) {
          selHtml = '<div class="mm-bof-fixed-list"><div class="mm-bof-fixed-header">' + 
            (mmoLang === "ar" ? "النكهات المشمولة" : "Included Flavors") + '</div>' +
            showVariants.map(function(v) { return '<div class="mm-bof-fixed-item">' + v.title + '</div>'; }).join("") + '</div>';
        } else if (showVariants.length > 1) {
          selHtml = '<select class="mm-bof-select" data-idx="' + idx + '">' +
            showVariants.map(function(v) { return '<option value="' + v.id + '" data-p="' + v.price + '">' + v.title + '</option>'; }).join("") + '</select>';
        } else if (showVariants[0] && showVariants[0].title !== "Default Title") {
          selHtml = '<div class="mm-bof-single-variant">' + showVariants[0].title + '</div>';
        }

        var qtyBadge = itemQty > 1 ? '<span class="mm-bof-qty-badge">×' + itemQty + '</span>' : '';

        var itemTitle = (mmoLang === "ar" && item.titleAr) ? item.titleAr : prod.title;
        html += '<div class="mm-bof-prod mm-bof-prod-row" data-idx="' + idx + '">' +
          '<div class="mm-bof-row-label">' + (mmoLang === "ar" ? "المنتج " : "Item ") + (idx + 1) + '</div>' +
          '<div class="mm-bof-img-wrap">' +
            '<img src="' + prod.featured_image + '" class="mm-bof-img" loading="lazy">' +
            qtyBadge +
          '</div>' +
          '<div class="mm-bof-row-info">' +
            '<span class="mm-bof-name">' + (isChoiceGroup ? (item.label || (mmoLang === "ar" ? "اختر منتجاً" : "Choose one")) : itemTitle) + '</span>' +
            selHtml +
          '</div>' +
        '</div>';
      });

      productsEl.innerHTML = html;

      productsEl.querySelectorAll("select.mm-bof-select").forEach(function(sel) {
        sel.addEventListener("change", function() {
          var idx = parseInt(this.dataset.idx);
          var opt = this.options[this.selectedIndex];
          variantSelections[idx].variantId = mmExtractId(this.value);
          variantSelections[idx].price = parseInt(opt.dataset.p) || 0;

          // Update variant-specific image!
          var selectedId = parseInt(this.value);
          var item = bundleItems[idx];
          var isChoiceGroup = item.options && item.options.length > 1;
          var prod;
          if (isChoiceGroup) {
            var choiceSel = productsEl.querySelector('select.mm-bof-product-choice[data-idx="' + idx + '"]');
            var optionIndex = choiceSel ? (parseInt(choiceSel.value) || 0) : 0;
            var prodList = Array.isArray(products[idx]) ? products[idx] : [];
            prod = prodList[optionIndex];
          } else {
            prod = Array.isArray(products[idx]) ? products[idx][0] : products[idx];
          }
          if (prod && prod.variants) {
            var v = prod.variants.find(function(vr) { return vr.id === selectedId; });
            if (v) {
              var imgUrl = (v.featured_image && v.featured_image.src) || prod.featured_image;
              var imgEl = productsEl.querySelector('.mm-bof-prod[data-idx="' + idx + '"] img.mm-bof-img');
              if (imgEl && imgUrl) imgEl.src = imgUrl;
            }
          }

          renderPrices();
        });
      });

      productsEl.querySelectorAll("select.mm-bof-product-choice").forEach(function(sel) {
        sel.addEventListener("change", function() {
          var idx = parseInt(this.dataset.idx);
          var item = bundleItems[idx];
          var optionIndex = parseInt(this.value) || 0;
          var option = (item.options || [])[optionIndex] || {};
          var prodList = Array.isArray(products[idx]) ? products[idx] : [];
          var selectedProd = prodList[optionIndex];
          if (!selectedProd) return;
          var variants = selectedProd.variants || [];
          if (option.variantMode === "specific") {
            var ids = (option.selectedVariantIds || []).map(function(id) { return String(id).split("/").pop(); });
            if (ids.length) variants = variants.filter(function(v) { return ids.indexOf(String(v.id)) > -1; });
          }
          if (!variants.length) variants = selectedProd.variants || [];
          var first = variants[0];
          var selectedQty = Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity || option.quantity || option.qty) || 1));
          if (option.isFixedSelection && variants.length > 1) {
            variantSelections[idx] = { handle: option.handle, isFixed: true, selected: variants, qty: selectedQty, discount: option.discount || "0", choiceGroupId: item._uid || item.id || ("choice-" + idx), options: item.options || [] };
          } else {
            variantSelections[idx] = {
              handle: option.handle,
              isFixed: false,
              variantId: first ? mmExtractId(first.id) : null,
              price: first ? first.price : 0,
              qty: selectedQty,
              discount: option.discount || "0",
              choiceGroupId: item._uid || item.id || ("choice-" + idx),
              options: item.options || []
            };
          }
          // Update product default image on choice change
          var imgEl = productsEl.querySelector('.mm-bof-prod[data-idx="' + idx + '"] img.mm-bof-img');
          if (imgEl && selectedProd.featured_image) imgEl.src = selectedProd.featured_image;

          var slot = productsEl.querySelector('.mm-bof-variant-slot[data-idx="' + idx + '"]');
          if (slot) {
            if (option.isFixedSelection && variants.length > 1) {
              slot.innerHTML = '<div class="mm-bof-fixed-list"><div class="mm-bof-fixed-header">' +
                (mmoLang === "ar" ? "الاختيارات المشمولة" : "Included variants") + '</div>' +
                variants.map(function(v) { return '<div class="mm-bof-fixed-item">' + v.title + '</div>'; }).join("") + '</div>';
            } else if (variants.length > 1) {
              slot.innerHTML = '<select class="mm-bof-select" data-idx="' + idx + '">' +
                variants.map(function(v) { return '<option value="' + v.id + '" data-p="' + v.price + '">' + v.title + '</option>'; }).join("") + '</select>';
              var variantSelect = slot.querySelector("select.mm-bof-select");
              variantSelect.addEventListener("change", function() {
                var opt = this.options[this.selectedIndex];
                variantSelections[idx].variantId = mmExtractId(this.value);
                variantSelections[idx].price = parseInt(opt.dataset.p) || 0;

                // Update variant-specific image!
                var selectedId = parseInt(this.value);
                var v = selectedProd.variants.find(function(vr) { return vr.id === selectedId; });
                if (v) {
                  var imgUrl = (v.featured_image && v.featured_image.src) || selectedProd.featured_image;
                  var iEl = productsEl.querySelector('.mm-bof-prod[data-idx="' + idx + '"] img.mm-bof-img');
                  if (iEl && imgUrl) iEl.src = imgUrl;
                }

                renderPrices();
              });
            } else {
              slot.innerHTML = variants[0] && variants[0].title !== "Default Title" ? '<div class="mm-bof-single-variant">' + variants[0].title + '</div>' : "";
              // Single variant, update to variant image if available
              if (variants[0]) {
                var imgUrl = (variants[0].featured_image && variants[0].featured_image.src) || selectedProd.featured_image;
                if (imgEl && imgUrl) imgEl.src = imgUrl;
              }
            }
          }
          renderPrices();
        });
      });

      renderPrices();

      container.style.setProperty("display", "block", "important");
      container.hidden = false;
      container.classList.add("mmo-card--ready");
      if (window.MMProductOffers) window.MMProductOffers.markVisible(container);

      // ── Mobile compact preview ──
      if (false && window.innerWidth <= 600) {
        var offerTitle = titleEl ? titleEl.textContent : (bundleOffer.title || "Bundle Deal");
        var previewProducts = [];
        products.forEach(function(p) {
          if (Array.isArray(p)) p.forEach(function(cp) { if (cp) previewProducts.push(cp); });
          else if (p) previewProducts.push(p);
        });
        var imgs = previewProducts.slice(0, 3).map(function(p) {
          return '<img src="' + (p.featured_image || '') + '" alt="">';
        }).join("");

        // Calculate actual discount % from renderPrices logic
        var previewTotal = 0;
        Object.values(variantSelections).forEach(function(s) {
          var q = s.qty || 1;
          if (s.isFixed) s.selected.forEach(function(v) { previewTotal += v.price * q; });
          else previewTotal += (s.price || 0) * q;
        });
        var previewDisc = 0;
        if (bundleOffer.discountMode === "PER_PRODUCT") {
          Object.values(variantSelections).forEach(function(s) {
            var q = s.qty || 1;
            var pDisc = parseFloat(s.discount || 0) / 100;
            if (s.isFixed) s.selected.forEach(function(v) { previewDisc += Math.round(v.price * pDisc) * q; });
            else previewDisc += Math.round((s.price || 0) * pDisc) * q;
          });
        } else if (bundleOffer.discountType === "PERCENTAGE") {
          previewDisc = Math.round(previewTotal * (bundleOffer.discountValue / 100));
        } else if (bundleOffer.discountType === "FIXED_EACH") {
          var cnt = 0;
          Object.values(variantSelections).forEach(function(s) { cnt += (s.isFixed ? s.selected.length : 1) * (s.qty || 1); });
          previewDisc = Math.round(bundleOffer.discountValue * 100) * cnt;
        } else {
          previewDisc = Math.round(bundleOffer.discountValue * 100);
        }
        var previewPct = previewTotal > 0 ? Math.round((previewDisc / previewTotal) * 100) : 0;

        var discBadge = "";
        if (previewPct > 0) {
          discBadge = (mmoLang === "ar" ? "وفر " : "Save ") + previewPct + "%";
        }

        var subText = bundleItems.length + " " + (mmoLang === "ar" ? "منتجات" : "Products");

        var preview = document.createElement("div");
        preview.className = "mm-mobile-preview";
        preview.style.background = getComputedStyle(container.querySelector(".mm-bof-header")).background || "var(--mm-accent)";
        preview.style.borderRadius = "14px 14px 0 0";
        preview.innerHTML =
          '<div class="mm-mobile-preview-imgs">' + imgs + '</div>' +
          '<div class="mm-mobile-preview-info">' +
            '<div class="mm-mobile-preview-title">' + offerTitle + '</div>' +
            '<div class="mm-mobile-preview-sub">' + subText + '</div>' +
          '</div>' +
          (discBadge ? '<span class="mm-mobile-preview-badge">' + discBadge + '</span>' : '') +
          '<div class="mm-mobile-preview-arrow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg></div>';

        container.insertBefore(preview, container.firstChild);
        container.classList.add("mm-mobile-collapsed");

        preview.addEventListener("click", function() {
          if (container.classList.contains("mm-mobile-collapsed")) {
            container.classList.remove("mm-mobile-collapsed");
            container.classList.add("mm-mobile-expanded");
          } else {
            container.classList.remove("mm-mobile-expanded");
            container.classList.add("mm-mobile-collapsed");
          }
        });
      }



      function renderPrices() {
        var total = 0;
        Object.values(variantSelections).forEach(function(s) {
          var q = s.qty || 1;
          if (s.isFixed) s.selected.forEach(function(v) { total += v.price * q; });
          else total += (s.price || 0) * q;
        });
        if (total <= 0) return;

        var disc = 0;
        if (bundleOffer.discountMode === "PER_PRODUCT") {
          Object.values(variantSelections).forEach(function(s) {
            var q = s.qty || 1;
            var pDisc = parseFloat(s.discount || 0) / 100;
            if (s.isFixed) s.selected.forEach(function(v) { disc += Math.round(v.price * pDisc) * q; });
            else disc += Math.round((s.price || 0) * pDisc) * q;
          });
        } else if (bundleOffer.discountType === "PERCENTAGE") {
          disc = Math.round(total * (bundleOffer.discountValue / 100));
        } else if (bundleOffer.discountType === "FIXED_EACH") {
          var count = 0;
          Object.values(variantSelections).forEach(function(s) {
            var q = s.qty || 1;
            count += (s.isFixed ? s.selected.length : 1) * q;
          });
          disc = Math.round(bundleOffer.discountValue * 100) * count;
        } else {
          disc = Math.round(bundleOffer.discountValue * 100);
        }

        var finalPrice = Math.max(0, total - disc);
        var pct = total > 0 ? Math.round((disc / total) * 100) : 0;

        var newEl = container.querySelector(".js-mm-bof-new");
        var oldEl = container.querySelector(".js-mm-bof-old");
        var pctEl = container.querySelector(".js-mm-bof-pct");
        if (newEl) newEl.textContent = mmFormatMoney(finalPrice);
        if (oldEl) oldEl.textContent = mmFormatMoney(total);
        if (pctEl) pctEl.textContent = pct > 0 ? ((mmoLang === "ar" ? "وفر " : "Save ") + pct + "%") : "";
      }

      var atcBtn = container.querySelector(".js-mm-bof-atc-v2");
      if (atcBtn) {
        atcBtn.textContent = mmoLang === "ar" ? (mmoSettings.addToCartAr || "أضف للسلة") : (mmoSettings.addToCartEn || container.dataset.sectionBtn || "Add Bundle to Cart");
        atcBtn.addEventListener("click", async function() {
          this.disabled = true;
          var original = this.textContent;
          this.innerHTML = '<span class="mm-btn-spinner"></span>' + (mmoLang === "ar" ? " جاري الإضافة..." : " Adding...");

          try {
            var bundleGroupId = "bg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 6);
            var props = { _offerId: bundleOffer.id, _offerType: "BUNDLE", _bundleGroupId: bundleGroupId };

            var bundleVids = {};
            for (var bIdx in variantSelections) {
              var bs = variantSelections[bIdx];
              if (!bs) continue;
              if (bs.isFixed && bs.selected) {
                bs.selected.forEach(function(v) {
                  var bv = mmExtractId(v.id);
                  if (bv) bundleVids[bv] = true;
                });
              } else if (bs.variantId) {
                bundleVids[mmExtractId(bs.variantId)] = true;
              }
            }

            var cartBefore = await (await fetch("/cart.js")).json();
            var updates = {};
            (cartBefore.items || []).forEach(function(item) {
              var iv = mmExtractId(item.variant_id);
              if (!iv || !bundleVids[iv]) return;
              if (item.properties && item.properties._bundleGroupId) return;
              updates[item.key] = 0;
            });
            if (Object.keys(updates).length) {
              await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: updates })
              });
            }

            var items = [];
            for (var idx in variantSelections) {
              var s = variantSelections[idx];
              var q = s.qty || 1;
              if (s.isFixed) {
                s.selected.forEach(function(v) { items.push({ id: mmCartVariantId(v.id), quantity: q, properties: props }); });
              } else if (s.variantId) {
                items.push({ id: mmCartVariantId(s.variantId), quantity: q, properties: props });
              }
            }

            var cartRes = await fetch("/cart/add.js", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: items })
            });
            if (!cartRes.ok) throw new Error("Cart add failed");

            var bundleDeals = [];
            var offerKey = String(bundleOffer.id);
            for (var idx2 in variantSelections) {
              var vs = variantSelections[idx2];
              if (!vs) continue;
              var q = vs.qty || 1;
              var dValue = mmBundleDealDiscount(vs, bundleOffer);
              if (vs.isFixed) {
                vs.selected.forEach(function(v) {
                  var vid = mmExtractId(v.id);
                  if (!vid) return;
                  bundleDeals.push({ variantId: vid, discountPercent: dValue, type: "bundle", offerId: offerKey, quantity: q });
                });
              } else {
                var selVid = mmExtractId(vs.variantId);
                if (selVid) {
                  bundleDeals.push({ variantId: selVid, discountPercent: dValue, type: "bundle", offerId: offerKey, quantity: q });
                }
              }
            }

            var cart = await (await fetch("/cart.js")).json();
            var existingDeals = [];
            try { existingDeals = JSON.parse(cart.attributes._flash_deals_data || "[]"); } catch(e) {}
            var merged = (window.MMOffers && window.MMOffers.mergeOfferDeals)
              ? window.MMOffers.mergeOfferDeals(existingDeals, bundleDeals, offerKey)
              : existingDeals.filter(function(d) { return String(d.offerId) !== offerKey; }).concat(bundleDeals);

            await fetch("/cart/update.js", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ attributes: { _flash_deals_data: JSON.stringify(merged), _mm_country: window.MMOffers && window.MMOffers.marketCountry ? window.MMOffers.marketCountry() : "BH" } })
            });

            this.innerHTML = mmoLang === "ar" ? "✓ تمت الإضافة!" : "✓ Added!";
            this.style.background = "#10b981";
            var finalCart = await (await fetch("/cart.js")).json();
            if (window.MMOffers && window.MMOffers.openCartSheet) {
              await window.MMOffers.openCartSheet(finalCart);
            } else if (window.MMCart && window.MMCart.refresh) {
              var refreshed = await window.MMCart.refresh();
              if (window.MMCart.open) window.MMCart.open({ skipRefresh: true, cart: refreshed });
            }
            var btn = this;
            setTimeout(function () {
              btn.disabled = false;
              btn.innerHTML = original;
              btn.style.background = "";
            }, 1600);
          } catch(err) {
            console.error("MM Bundle ATC:", err);
            this.disabled = false;
            this.textContent = original;
            this.style.background = "";
          }
        });
      }
    } catch(err) {
      console.error("MM Bundle block:", err);
    }
  }

  function startTimer(endsAt, el) {
    if (!endsAt || !el) return;
    var endMs = new Date(endsAt).getTime();
    function tick() {
      var left = endMs - Date.now();
      if (left <= 0) { el.textContent = mmoLang === "ar" ? "انتهى" : "Expired"; return; }
      var d = Math.floor(left / 86400000), h = Math.floor((left % 86400000) / 3600000);
      var m = Math.floor((left % 3600000) / 60000), s = Math.floor((left % 60000) / 1000);
      var pad = function(n) { return (n < 10 ? "0" : "") + n; };
      if (d >= 3) el.textContent = d + (mmoLang === "ar" ? " أيام " : "d ") + pad(h) + ":" + pad(m) + ":" + pad(s);
      else el.textContent = pad(d * 24 + h) + ":" + pad(m) + ":" + pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  }

  if (!document.querySelector('[data-mm-offer-landing]')) {
    init();
  }
  document.addEventListener('mm:offer-widgets-mount', init);
})();
